<template>
  <div class="loginIndexBG" style="margin:0 auto;">

    <div class="h-topbar">
      <div class="h-topbar-expandIcon">
        <img src="../assets/logo.png"  style="height: 30px;">
        <span></span>营销开发平台
      </div>
      <div class="h-topbar-tool" ref="topbarTool">
        <h-menu theme="dark" mode="horizontal">

        </h-menu>
      </div>
    </div>


    <div class="contentBoxS">
      <div class="contentBoxSC">
        <div class="contentBoxSCL">
          <div class="zBian">帮助与支持</div>
          <div>
            <div class="item" :class="{'act':popshow==1}" @click="selecHandler('1')">平台介绍</div>
            <div class="item" :class="{'act':popshow==2}" @click="selecHandler('2')">联系我们</div>
            <div class="item" :class="{'act':popshow==3}" @click="selecHandler('3')">开放接口文档</div>
          </div>
        </div>
        <div class="contentBoxSCR">
          <!-- 平台介绍 -->
          <div class="contentBoxSCRc" v-if="popshow==1">
            <div class="contentBoxSCRcT">
              <div class="contentBoxSCRcT">
             平台介绍
              </div>
              <div class="title">
               小营加营销开发平台是恒生电子股份有限公司控股子公司鲸腾网络旗下的
            开发平台，依托于恒生公司不断的技术创新和研发积累，通过小营加营销开发平
            台能够解决营销活动组件技术复用的难点，大大提高开发效率与并行能力并且支
            持活动信息灵活可配。
              </div>
              <div class="title">
                 小营加营销开发平台支持客户营销活动的整个流程，客户提出营销活动需求，
            平台运营与产品人员即可快速制定策划方案与需求原型，并将开发需求通过平台
            对外发包，由平台合作的高质量ISV团队进行接包开发，开发过程中基于平台
            提供的活动设置、活动组件管理等功能支持实现快速开发，最终交由平台测试验
            收后提供客户验收交付，实现最终活动的快速上线，并且平台提供持续运营能力，
            支持活动信息的灵活配置，以及活动数据的报告分析，为客户营销活动赋能。
              </div>

            </div>
            <img src="../assets/workflow.png">
          </div>
         <!--  联系我们 -->
          <div class="contentBoxSCRc"v-if="popshow==2">
            <div class="contentBoxSCRcT">
              联系我们
            </div>
            <div class="text" style="">
             联系电话： 0571-26693504 （09:00-17:00）
            </div>
            <div class="text">
              邮箱地址： xiaoyingjia@hundsun.com

            </div>
            <div class="text">
               客服QQ: 2235689515
            </div>
            <div class="text">
              联系地址： 杭州市滨江区江南大道3588号恒生大厦
            </div>

          </div>
          <!-- 开放接口文档 -->
          <div class="contentBoxSCRc" v-if="popshow==3">
            <div class="contentBoxSCRcT">
             开放接口文档
            </div>
            <div class="document"  @click="documentHandler">接口文档下载</div>
            <div class="document" @click="demoHandler">demo下载</div>
          </div>
        </div>
      </div>

    </div>









  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LockScreen from '@/components/LockScreen'
import fetch from '@/api/httpFetch.js'
import { allToggleClass } from '@/utils'
 import {rServiceValidate,getResourceMenu } from "@/api/bizApi/commonUtil";
// import secret from '../../../secret/secret.js'
export default {
  data() {

    let options={
      popshow:1,
      locationHost:'',//
      locationProtocol:'',//获取协议
      URL:'',

    }
    return options
  },
  components: {

  },

  computed: {

  },
  watch: {

  },
  methods: {

    selecHandler(num){
      if(num==this.popshow){
        return false;
      }
      this.popshow=num
    },

    //下载文档资料函数
    documentHandler(){
      window.open(window.location.href.split("#")[0]+'files/api-doc.xlsx',"_blank");
    },
    //下载案例
    demoHandler(){
       window.open(window.location.href.split("#")[0]+'files/demo.source.jar',"_blank");
    },

    //帮助与支持按钮函数
    helpHandler(){
        window.open(window.location.href.split("#")[0]+'#/help',"_blank");
    },


  },
  created() {
    this.URL = window.location.href;
    this.locationHost=window.location.host;
    this.locationProtocol=window.location.protocol;
  },
  mounted() {
    document.getElementsByTagName('html')[0].style.padding='0';

  }
}

</script>
<style scoped lang="scss">
.loginIndexBG{
  background:#E9EEF4;
}
.h-topbar{
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 64px;
  background:linear-gradient(190deg,rgba(33,15,217,1) 0%,rgba(38,59,243,1) 100%);
}
.h-topbar-tool{
  right: 203px;
}
.h-topbar-expandIcon{
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight:400;
  color:#fff;
  margin-left:203px;
}
.h-topbar-expandIcon span{
  display: inline-block;
  height: 18px;
  line-height: 18px;
  border-left:1px solid #fff;
  margin:0 20px;

}
.pT{
  color: #fff;
  text-align: left;
  padding-bottom: 0;
  font-size: 14px;
  margin-bottom: 10px;
  margin-right:20px;
  font-weight: 400;
}
.pT:hover,.mov:hover{
  cursor:pointer
}
.contentBoxS{
  padding-top: 64px;
  background: #fff;
}

.contentBoxSC{
  overflow: hidden;
  padding:20px;
}
.contentBoxSCL{
  float: left;
  width: 15%;
  border:1px solid #e5e7eb;

}
.contentBoxSCR{
  float: left;
  width: 85%;
}
.zBian{
    padding: 9px 30px 9px 20px;
    line-height: 32px;
    text-align: center;
    background: transparent;
    font-size: 18px;
    font-weight: 700;
    border-radius: 6px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 700;
    color: #555;
}

.contentBoxSCRc{
  font-size: 14px;
  text-align: left;
  padding-left:10px;
}
.contentBoxSCRcT{
  margin-bottom: 10px;
}
.item{
  font-size: 14px;
  line-height: 40px;
  text-align: center;
}
.item:hover{
  cursor:pointer
}

.item.act{
  color: #fff;
  background-color: #0ae;
}
.document{
  font-size:14px;
  margin-bottom:10px;
}
.document:hover{
  cursor:pointer
}
.contentBoxSCRcT{
  font-size: 20px;
  margin-bottom:10px;
}
.text{
  font-size: 14px;
  margin-bottom:10px;
}
.title{
  font-size: 16px;
  text-indent:2em;
  margin-bottom: 10px;
}
// .title span{
//   margin-left: 33px;
// }
</style>



// WEBPACK FOOTER //
// src/views/help.vue